
export const FETCH_TABLE_REQUEST = "FETCH_TABLE_REQUEST";
export const FETCH_TABLE_SUCCESS = "FETCH_TABLE_SUCCESS";
export const FETCH_TABLE_FAILURE = "FETCH_TABLE_FAILURE";

export const FETCH_FLOORS_SUCCESS = "FETCH_FLOORS_SUCCESS";

export const CREATE_TABLE_REQUEST = "CREATE_TABLE_REQUEST";
export const CREATE_TABLE_SUCCESS = "CREATE_TABLE_SUCCESS";
export const CREATE_TABLE_FAILURE = "CREATE_TABLE_FAILURE";

export const UPDATE_TABLE_REQUEST = "UPDATE_TABLE_REQUEST";
export const UPDATE_TABLE_SUCCESS = "UPDATE_TABLE_SUCCESS";
export const UPDATE_TABLE_FAILURE = "UPDATE_TABLE_FAILURE";

export const DELETE_TABLE_REQUEST = "DELETE_TABLE_REQUEST";
export const DELETE_TABLE_SUCCESS = "DELETE_TABLE_SUCCESS";
export const DELETE_TABLE_FAILURE = "DELETE_TABLE_FAILURE";
